import PropTypes from 'prop-types';
import React from 'react';

import { FundItem } from '$partials/listings/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const FundCards = ({ sidebarTitle, items }) => {

    return (
        <div className='layout-container-padding-right flex flex-wrap max-w-container pt-70 sm:pt-80'>
            {/* Left Sidebar */}
            <div className='w-sidebar'>
                <div className='flex flex-col items-center'>
                    <h2 className='type-style-8 inline-block align-middle rotate-180 writing-mode-vertical-rl'>
                        {sidebarTitle}
                    </h2>
                </div>
            </div>

            <div className='flex-1'>
                <section className='flex-1 flex flex-wrap self-start'>
                    {items?.length > 0 &&
                        <div className='w-full grid grid-cols-1 sm:grid-cols-2 layout-gap gap-y-20 sm:gap-25 md:gap-30'>
                            {items.map((item, i) => {
                                return (
                                    <article
                                        className='-mr-20 sm:mr-0'
                                        key={i}>
                                        <FundItem
                                            {...item} />
                                    </article>
                                );
                            })}
                        </div>
                    }
                </section>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    sidebarTitle: PropTypes.string,
    items: PropTypes.array,
};


FundCards.propTypes = propTypes;

export default FundCards;
